class ProductForm extends HTMLElement {
  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant, variantUrl } = e.detail;
      this.currentVariant = variant;

      this._updateAtc(variant, variantUrl);
      this._updateIdInputs(variant);

      if (!variant) return;

      this._updatePrices(variant);
      this._updateUrl(variant);
    });
  }

  get atc() {
    return this.querySelector("[data-product-form-atc]");
  }

  get bisButton() {
    return this.querySelector("[data-product-form-bis]");
  }

  get prices() {
    return document.querySelectorAll("[data-main-product-price]");
  }

  get idInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  get comingSoon() {
    return this.dataset.comingSoon === "true";
  }

  get waitlist() {
    return this.dataset.waitlist === "true";
  }

  get soldOutMessage() {
    return this.querySelector(".product-form__option-sold-out-message");
  }

  _updateAtc(variant, variantUrl) {
    const btn = this.atc;
    const bisBtn = this.bisButton;
    const content = btn?.querySelector("add-to-cart");

    if (!variant?.available && (this.comingSoon || this.waitlist)) {
      if (btn) btn.style.display = "none";
      if (bisBtn) {
        bisBtn.style.display = "";
        if (variantUrl) bisBtn.setAttribute("url", variantUrl);
        if (variant?.id) bisBtn.setAttribute("selected-variant", variant.id);
        const bisButtonEl = bisBtn.querySelector("[data-bis-button]");
        if (bisButtonEl) {
          bisButtonEl.textContent = this.comingSoon
            ? this.dataset.localeComingSoon
            : this.dataset.localeNotifyMe;
        }
      }
      if (this.soldOutMessage) this.soldOutMessage.style.display = "none";
    } else if (!variant?.available) {
      if (btn) {
        btn.disabled = true;
        btn.style.display = "";
        if (content) content.textContent = this.dataset.localeSoldOut;
      }
      if (bisBtn) bisBtn.style.display = "none";
      if (this.soldOutMessage) this.soldOutMessage.style.display = "";
    } else {
      if (btn) {
        btn.disabled = false;
        btn.style.display = "";
        if (content) content.textContent = this.dataset.localeAdd;
      }
      if (bisBtn) bisBtn.style.display = "none";
      if (this.soldOutMessage) this.soldOutMessage.style.display = "none";
    }
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => this._updatePriceEl(price, variant));
  }

  _updateIdInputs(variant) {
    this.idInputs.forEach((input) => {
      input.value = variant?.id || "";
    });
  }

  _updateUrl(variant) {
    if (!window.Shopify?.designMode && this.updateUrl) {
      const url = new URL(window.location);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
    }
  }

  _updatePriceEl(price, variant) {
    price.setAttribute("price", variant.price / 100);
    price.setAttribute("compare-at-price", variant.compare_at_price / 100);
    price.setAttribute("currency", window.Shopify.currency.active);
    price.setAttribute("dynamic", "");
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
